import React, { useEffect, useState } from 'react';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import '../styles/Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import PcMenu from './PcMenu';
import SideItem from '../dashboards/SideItem';

const MobileMenu = ({ closeMenu, isOpen }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // Handle authentication state
    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setIsAuthenticated(!!user);
        });

        return () => unsubscribe();
    }, []);

    // Handle screen resize
    useEffect(() => {
        const handleResize = () => {
            const isNowMobile = window.innerWidth <= 768;
            setIsMobile(isNowMobile);

            // Close the mobile menu if screen width switches to PC
            if (!isNowMobile && isOpen) {
                closeMenu();
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isOpen, closeMenu]);

    return (
        <div className={`mobile-menu ${isOpen && isMobile ? 'open' : ''}`}>
            <>
                <FontAwesomeIcon icon={faTimes} className="close-btn" onClick={closeMenu} />
            </>
            {isAuthenticated ? (
                <SideItem closeMenu={closeMenu} />
            ) : (
                <PcMenu closeMenu={closeMenu} />
            )}
        </div>
    );
};

export default MobileMenu;
